import { createContext, useContext, useMemo, useState } from "react";

const CommerceApiStoreInfoValueContext = createContext();
const CommerceApiStoreInfoActionsContext = createContext();

export function CommerceApiStoreInfoContextProvider({ children }) {
    const [commerceApiStoreInfos, setCommerceApiStoreInfos] = useState(null);

    const commerceApiStoreInfosActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setCommerceApiStoreInfos(newValues);
                },
                setValue: setCommerceApiStoreInfos
            }
        },
        []
    )

    return (
        <>
            <CommerceApiStoreInfoActionsContext.Provider value={{ commerceApiStoreInfos: commerceApiStoreInfosActions }}>
                <CommerceApiStoreInfoValueContext.Provider value={{ commerceApiStoreInfos }}>
                    {children}
                </CommerceApiStoreInfoValueContext.Provider>
            </CommerceApiStoreInfoActionsContext.Provider>
        </>
    );
}

export function useCommerceApiStoreInfoValueContextHook(props) {
    const value = useContext(CommerceApiStoreInfoValueContext);

    if (value === undefined) {
        throw new Error('useCommerceApiStoreInfoValueContextHook should be used within CommerceApiStoreInfoValueContext');
    }

    return {
        commerceApiStoreInfos: value.commerceApiStoreInfos
    };
}

export function useCommerceApiStoreInfoActionsContextHook(props) {
    const value = useContext(CommerceApiStoreInfoActionsContext);

    if (value === undefined) {
        throw new Error('useCommerceApiStoreInfoActionsContextHook should be used within CommerceApiStoreInfoActionsContext');
    }

    return {
        commerceApiStoreInfos: {
            onSet: value.commerceApiStoreInfos.onSet,
            setValue: value.commerceApiStoreInfos.setValue
        }
    };
}